import React, { Component, PropTypes } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import GroupFormLinks from "./GroupFormLinks";
import { connect } from "react-redux";
import _ from 'lodash';


import Card from "./bootstrap/Card";
import CardHeader from "./bootstrap/CardHeader";
import CardBlock from "./bootstrap/CardBlock";
import {
    SUBMISSION__CREATE__REQUESTED,
    SUBMISSION__UPDATE__REQUESTED,
    SUBMISSION__MEMBERSHIP__DELETE__REQUESTED
} from "../constants/actionTypes";
import { ADMIN, INSTRUCTOR, INSTRUCTOR_VIEW_ONLY, STUDENT} from "../constants/roles";
import { getMappedKeyEntities } from "../helpers/helpers";

class GroupForm extends Component {
    constructor(props) {
        super(props);

        const memberships = this.getMemberships(),
            users = this.getUsers()
        ;

        const { auth, dropbox, roles, roles_self, submission } = this.props,
            highestRole = this.getHighestRole(
                _.filter(
                    roles_self,
                    role => {
                        return role.dropbox.id === dropbox.id;
                    }
                )
            ),
            formattedUsers = _.orderBy(
                _.filter(
                    _.map(
                        _.map(
                            users,
                            user => {
                                const existingMembership = _.filter(
                                    memberships,
                                    membership => {
                                        return membership.user.id === user.id;
                                    }
                                ).length > 0;

                                return !existingMembership && user.id !== parseInt(auth.id)
                                ?
                                    {
                                        id: user.id,
                                        username: user.username,
                                        first_name: user.first_name,
                                        last_name: user.last_name,
                                        role: this.getHighestRole(
                                            _.filter(
                                                roles,
                                                role => {
                                                    return role.user.id === user.id;
                                                }
                                            )
                                        )
                                    }
                                : false;
                            }
                        ),
                        user => {
                            return {
                                ...user,
                                label: `${user.first_name} ${user.last_name} <${user.username}>`,
                            };
                        }
                    ),
                    user => {
                        return user.username !== undefined && highestRole === user.role && highestRole !== null;
                    }
                ),
                [
                    formattedUser => {
                        return formattedUser.last_name;
                    }
                ],
                ['asc']
            ),
            current_group_users = _.map(
                _.filter(
                    memberships,
                    membership => {
                        const { id } = submission;

                        return membership.submission.id === id;
                    }
                ),
                membership => {
                    const { user } = membership;

                    return {
                        id : user.id,
                        confirmed : membership.confirmed,
                        notified : membership.notified,
                        label : `<${user.username}>`,
                        user : {
                            'id' : user.id,
                            'username': user.username,
                        }
                    };
                }
            )
        ;

        this.addGroupMember = this.addGroupMember.bind(this);
        this.handleGroupUpdate = this.handleGroupUpdate.bind(this);
        this.handleLeaveGroup = this.handleLeaveGroup.bind(this);
        this.clearSelectedUsers = this.clearSelectedUsers.bind(this);

        this.state = {
            current_group_users: current_group_users,
            formattedUsers: formattedUsers,
            selected_users: []
        };
    }

    getHighestRole(roles) {
        return _.last(
            _.sortBy(
                roles,
                [
                    dropbox_role => {
                        return dropbox_role.role === ADMIN;
                    },
                    dropbox_role => {
                        return dropbox_role.role === INSTRUCTOR;
                    },
                    dropbox_role => {
                        return dropbox_role.role === INSTRUCTOR_VIEW_ONLY;
                    },
                    dropbox_role => {
                        return dropbox_role.role === STUDENT;
                    }
                ]
            )
        ).role;
    }

    getMemberships() {
        const { memberships } = this.props;

        return getMappedKeyEntities(memberships);
    }

    getUsers() {
        const { users } = this.props;

        return getMappedKeyEntities(users);
    }

    handleGroupUpdate(e) {
        e.preventDefault();

        const { assignment, auth, dispatch, submission, type } = this.props,
            memberships = this.getMemberships(),
            { selected_users } = this.state,
            unionMemberships = _.unionBy (
                _.map(
                    type === CREATE
                     ?
                        [
                            {
                                user: {
                                    id: auth.id,
                                }
                            }
                        ]
                    :
                        _.filter(
                            memberships,
                            membership => {
                                return membership.submission.id === submission.id;
                            }
                        )
                    ,
                    membership => {
                        return type === CREATE
                        ?
                            {
                                user: membership.user.id,
                                assignment: assignment.id,
                                confirmed: true,
                                notified: true,
                            }
                        :
                            {
                                user: membership.user.id,
                                assignment: assignment.id,
                                confirmed: membership.confirmed !== undefined ? membership.confirmed : false,
                                notified: membership.notified !== undefined ? membership.notified : false,
                            }
                        ;
                    }
                ),
                _.map(
                     selected_users,
                     selected_user => {
                        return {
                            confirmed: false,
                            notified: false,
                            user: selected_user.id,
                            assignment: assignment.id
                        };
                    }
                ),
                membership => {
                    return membership.user;
                }
             )
        ;

        if (type === CREATE) {
            dispatch({
                type: SUBMISSION__CREATE__REQUESTED,
                payload: {
                    submission: {
                        memberships: unionMemberships,
                        assignment: assignment.id,
                        refresh_assignment: true,
                        not_done: false
                    },
                    assignment: assignment
                }
            });
        }

        if (type === UPDATE) {
            dispatch({
                type: SUBMISSION__UPDATE__REQUESTED,
                payload: {
                    submission: {
                        ...submission,
                        assignment: assignment.id,
                        memberships: unionMemberships,
                    },
                }
            });
        }
    }

    handleLeaveGroup(){
        const { auth, assignment, submission } = this.props,
            memberships = this.getMemberships(),
            membership = _.filter(
                memberships,
                membership => {
                    return membership.submission.id === submission.id && membership.user.id === parseInt(auth.id);
                }
            )[0]
        ;

        this.props.dispatch({
            type: SUBMISSION__MEMBERSHIP__DELETE__REQUESTED,
            payload: {
                assignment: assignment,
                membership: membership
            }
        });
    }

    addGroupMember(selected_users) {
        this.setState({
            selected_users : selected_users
        });
    }

    clearSelectedUsers() {
        this.setState({
            selected_users: []
        });
    }

    render() {
        const { assignment, dropbox, type } = this.props,
            { current_group_users, formattedUsers, selected_users } = this.state,
            allow_add_user = (current_group_users.length + selected_users.length + (type === CREATE ? 1 : 0)) <  assignment.students_per_group_max
        ;

        return (
            <div className="col-md-12">
                <div className={"action-links"}>
                    <GroupFormLinks
                        assignment={assignment}
                        dropbox={dropbox}
                        handleSubmit={this.handleGroupUpdate}
                        handleLeaveGroup={this.handleLeaveGroup}
                        type={this.props.type}
                    />
                </div>
                <h3>{dropbox.name}</h3>
                <Card>
                    <CardHeader className="bg-primary">Group - {_.upperFirst(this.props.type)}</CardHeader>
                    <CardBlock>
                        <h5>Assignment: {assignment.name}</h5>
                        <form
                            onSubmit={
                                e => {
                                    e.preventDefault();
                                }
                            }
                            className="border-top-0"
                        >
                            <div
                                id="collapseOne"
                                className="collapse show"
                                role="tabpanel"
                                aria-labelledby="headingOne"
                            >
                                <CardBlock>
                                    <Card>
                                        <CardHeader>
                                            Group Members&nbsp;
                                            {
                                                assignment.students_per_group_max
                                                    ?
                                                    <span>
                                                        <small>
                                                            (Min: {assignment.students_per_group_min}, Max: {assignment.students_per_group_max})
                                                        </small>
                                                    </span>
                                                    : null
                                            }
                                        </CardHeader>
                                        <div id="user-search" className="col-md-12">
                                            Add members&nbsp;
                                            <div className="input-group col-md-12">
                                                <Typeahead
                                                    className="col-md-11"
                                                    labelKey="label"
                                                    multiple={true}
                                                    onChange={this.addGroupMember}
                                                    disabled={!allow_add_user}
                                                    options={formattedUsers}
                                                    placeholder={allow_add_user? "Choose a user..." : "Disabled - reached max members"}
                                                    selected={selected_users}
                                                />
                                                {
                                                    selected_users.length > 0
                                                    ?
                                                        <div className="input-group-append">
                                                            <button
                                                                id="clear-group-members"
                                                                className="btn btn-md btn-info"
                                                                type="button"
                                                                onClick={this.clearSelectedUsers}
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>
                                                    : null
                                                }
                                            </div>
                                            <small>
                                                <i><b>*Note</b>:  You are automatically included in the group.  Group members must confirm group membership before uploading / submitting files.</i>
                                            </small>
                                        </div>
                                        <div className="mt-3 col-md-12">
                                            {
                                                this.props.type === UPDATE
                                                ?
                                                <div>
                                                    Current members <br/>
                                                    <code>
                                                        {
                                                            _.map(
                                                                current_group_users,
                                                                user => {
                                                                    return (
                                                                        <div key={user.id}>
                                                                            {user.label} - {user.confirmed ? "confirmed" : "waiting on group membership confirmation"}
                                                                        </div>
                                                                    );
                                                                }
                                                            )
                                                        }
                                                    </code>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </Card>
                                </CardBlock>
                            </div>
                        </form>
                    </CardBlock>
                </Card>
            </div>
        );
    }
}

GroupForm.propTypes = {
    auth: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropbox: PropTypes.object.isRequired,
    dropboxes: PropTypes.object.isRequired,
    memberships: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    submission: PropTypes.object.isRequired,
    submissions: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    const { auth, dropboxes, memberships, request, roles, roles_self, submissions, users } = state;

    return { auth, dropboxes, memberships, request, roles, roles_self, submissions, users };
}

export const CREATE = 'create';
export const UPDATE = 'update';

export default connect(mapStateToProps)(GroupForm);



/** WEBPACK FOOTER **
 ** ./src/components/GroupForm.js
 **/